#wrapper {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: var(--spacer);
}

#license-type-form-field {
  max-width: 490px;
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 1.5);
  margin-bottom: var(--spacer);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

.form-subtitle-info {
  margin-top: calc(var(--spacer) * 2);
  font-size: var(--body-size);
  color: var(--body-text-arrows-400);
}
